import debounce from 'lodash.debounce';

(function ($) {
    'use strict';

    function setupRoveSearch () {
        const inputField = $('#Form_roVEIndustrySearchForm_Industry');
        let id = 0;

        const doSearch = function () {
            if ($(this).val().length > 2) {
                id++;
                $('#RoVEIndustriesResults').html('<img src="/_resources/themes/tec-theme/dist/images/loading.gif">');

                $.ajax({
                    method: 'GET',
                    url: buildUrl(window.location.pathname, $(this).val(), id),
                    dataType: 'JSON',
                    success: function (response) {
                        if (id === Number(response.id)) {
                            let output = response.noResultsMessage;

                            if (response.results.length > 0) {
                                output = renderResults(response.results);
                            }

                            $('#RoVEIndustriesResults').html(output);
                        }
                    }
                });
            } else {
                $('#RoVEIndustriesResults').empty();
            }
        };

        inputField.keyup(debounce(doSearch, 250));
    }

    function buildUrl (pathName, searchValue, requestId) {
        let trimmedPathName = '';

        if (endsWith(pathName, '/')) {
            trimmedPathName += pathName.slice(0, -1);
        } else {
            trimmedPathName += pathName;
        }

        return `${trimmedPathName}/getIndustries/${encodeURIComponent(searchValue)}/${requestId}${window.location.search}`;
    }

    function endsWith (string, search, thisLen) {
        if (thisLen === undefined || thisLen > string.length) {
            thisLen = string.length;
        }

        return string.substring(thisLen - search.length, thisLen) === search;
    }

    function renderResults (results) {
        if (results.length === 0) {
            return results.noResultsMessage;
        }

        const heading = `<div class="row title">
            <div class="columns">
                <div class="column"><strong>Titles</strong></div>
                <div class="column industry-name"><strong>WDC</strong></div>
            </div>
        </div>`;

        const output = results.map((result) => {
            const altTitle = result.alternateTitle ? `<br /><small>[ ${result.alternateTitle} ]</small>` : '';

            return `<div class="row">
                <div class="columns">
                      <div class="column">
                            ${result.title}
                            ${altTitle}
                            <br /><small><strong>${result.topLevelNames}</strong></small>
                      </div>
                      <div class="column industry-name">${result.industryName}</div>
                </div>
            </div>`;
        });

        return heading + output.join('');
    }

    $(document).ready(() => {
        setupRoveSearch();
    });
}(jQuery));



// WEBPACK FOOTER //
// ./src/js/app/rove-search.js